module.exports = __webpack_public_path__ + "img/select.8a7d2359.svg";